import http from "@/utils/httpRequest";
let baseURL = window.PUR_HTTP_API;
/*获取列表页数据*/
const httpMixinsList = (url,params)=>{
    return http.post(url,params,{baseURL})
}

/*删除列表数据*/
const httpMixinsDelete = (url,params)=>{
    return http.post(url,params,{baseURL})
}
/*获取详情页基本信息*/
const httpMixinsDetail = (url)=>{
    return http.get(url,{baseURL})
}

const httpMixinsSave = (url,params)=>{
    return http.post(url,params,{baseURL})
}
const httpMixinsSubmit = (url,params)=>{
    return http.post(url,params,{baseURL})
}

const httpMixinsCommonPost = (url,params)=>{
    return http.post(url,params,{baseURL})
}

const httpMixinsCommonGet = (url)=>{
    return http.get(url,{baseURL})
}

//获取数据字典
const httpSuiteLoadDicts = (type)=>{
    return http.post(`/suite/loadDicts/${type}`, {}, {baseURL})
}

//获取附件数据
const httpGetAttsByBusinessId = (type, businessId, enableEdit)=>{
    return http.post(`/atts/getAttsByBusinessId?type=${type}&businessId=${businessId}&enableEdit=${enableEdit}`, {}, {baseURL})
}
//获取采购品目下拉数据
const httpSysPurcatalogList = (params)=>{
    return http.post(`/purchase/item/loadPurchaseItem`, params, {baseURL})
}

export {
    httpMixinsList,
    httpMixinsDetail,
    httpMixinsDelete,
    httpMixinsSave,
    httpMixinsSubmit,
    httpMixinsCommonGet,
    httpMixinsCommonPost,
    httpSuiteLoadDicts,
    httpGetAttsByBusinessId,
    httpSysPurcatalogList

}

